<template lang="pug">
#reservation-schedule-template-register(v-cloak)
  .box
    .box-header.with-border.register-header
      .title
        span 一括設定の新規作成

    .box-body.register-body
      //- name
      FormInput(v-model="name" key-name="設定名" name="name" type="text" placeholder="設定名"
        :maxlength="100" :validation-rules="{ required: true, max: 100 }" :styles="{ 'min-width': '340px' }" required)

      //- weeks
      span.week-title 設定内容
      span.week-note 月～金の9:00～10:00と土日の14:00～15:00など、複数の設定を登録することができます。
      .week(v-for="(week, index) in weeks" :key="index" :class="{ 'mb-2': index + 1 != weeks.length }")
        .flex-fill.d-flex.flex-row-reverse
          button.btn.add-btn(@click="onDeleteWeek(index)" type="button") 削除
        //- input week
        .register-row.input-week
          .register-group
            .register-key
              span.key-name 曜日
              span.validation-label 必須
            .register-value.flex-wrap
              //- inputはcheckboxだがラジオボタンと同じ見た目にしたいのでcssクラスはラジオボタンのものを使用する
              label.register-radio-label
                input.register-radio-form(v-model="week.sunday" name="sunday" type="checkbox")
                span.register-radio-text 日曜日
              label.register-radio-label
                input.register-radio-form(v-model="week.monday" name="monday" type="checkbox")
                span.register-radio-text 月曜日
              label.register-radio-label
                input.register-radio-form(v-model="week.tuesday" name="tuesday" type="checkbox")
                span.register-radio-text 火曜日
              label.register-radio-label
                input.register-radio-form(v-model="week.wednesday" name="wednesday" type="checkbox")
                span.register-radio-text 水曜日
              label.register-radio-label
                input.register-radio-form(v-model="week.thursday" name="thursday" type="checkbox")
                span.register-radio-text 木曜日
              label.register-radio-label
                input.register-radio-form(v-model="week.friday" name="friday" type="checkbox")
                span.register-radio-text 金曜日
              label.register-radio-label
                input.register-radio-form(v-model="week.saturday" name="saturday" type="checkbox")
                span.register-radio-text 土曜日
            .error-messages(v-if="errors.has('day-of-week-' + index)")
              label.error-message {{ errors.first('day-of-week-' + index) }}

        //- input time
        .register-row.input-time(style="flex-wrap: nowrap;")
          .register-group(style="width: auto;")
            .register-key
              span.key-name 開始時間
              span.validation-label 必須
            .register-value
              select#start-hour.register-form.hour(
                :name="'start-hour-' + index"
                v-model="week.startHour"
                v-validate="{ required: true }"
                data-vv-as="開始時間（時）"
                :class="{ noinput: !week.startHour }"
              )
                option(v-for="hour in week.startHourOptions") {{ hour }}
              span 時

              select#start-min.register-form.min(
                :name="'start-min-' + index"
                v-model="week.startMin"
                v-validate="{ required: true }"
                data-vv-as="開始時間（分）"
                :class="{ noinput: !week.startMin, disable: startMinDisabled(week) }"
                :disabled="startMinDisabled(week)"
              )
                option(v-for="min in week.startMinOptions") {{ min }}
              span 分
            .error-messages(v-if="errors.has('start-hour-' + index) || errors.has('start-min-' + index) || errors.has('end-hour-' + index) || errors.has('end-min-' + index)")
              div(v-if="errors.has('start-hour-' + index)")
                label.error-message {{ errors.first('start-hour-' + index) }}
              div(v-if="errors.has('start-min-' + index)")
                label.error-message {{ errors.first('start-min-' + index) }}
              div(v-if="errors.has('end-hour-' + index)")
                label.error-message {{ errors.first('end-hour-' + index) }}
              div(v-if="errors.has('end-min-' + index)")
                label.error-message {{ errors.first('end-min-' + index) }}
          .register-group(style="width: auto;")
            .register-key
              span.key-name 終了時間
              span.validation-label 必須
            .register-value
              select#end-hour.register-form.hour(
                :name="'end-hour-' + index"
                v-model="week.endHour"
                v-validate="{ required: true }"
                data-vv-as="終了時間（時）"
                :class="{ noinput: !week.endHour, disable: endHourDisabled(week) }"
                :disabled="endHourDisabled(week)"
              )
                option(v-for="hour in week.endHourOptions") {{ hour }}
              span 時

              select#end-min.register-form.min(
                :name="'end-min-' + index"
                v-model="week.endMin"
                v-validate="{ required: true }"
                data-vv-as="終了時間（分）"
                :class="{ noinput: !week.endMin, disable: endMinDisabled(week) }"
                :disabled="endMinDisabled(week)"
              )
                option(v-for="min in week.endMinOptions") {{ min }}
              span 分
      //- add week
      .add-week.flex-fill.d-flex.flex-row-reverse.mt-2
        button.btn.add-btn(@click="onAddWeek" type="button" :class="{ 'disable': _disableAddWeek }" :disabled="_disableAddWeek") 追加

    .box-footer.with-border.register-footer
      ValidationAlert(v-model="showValidationAlert")
      .buttons
        button.btn.register-btn(@click="showConfirmModal" type="button") 登録
        button.btn.cancel-btn(@click="gotoTemplateList" type="button") キャンセル

  OkCancelModal(v-model="showRegisterModal" title="設定を登録しますか？" @ok="registerTemplate")
  OkModal(v-model="showRegisterSuccessModal" title="登録に成功しました。" @ok="gotoTemplateList")
  
  Loading(:isBusy="isBusy" :message="loadingMessage")
</template>

<script lang="ts">
import { Component, Inject, Watch, Vue } from "vue-property-decorator";
import { userStore } from "@/store/store";

import { PcUrl } from "@/commons/constants/PcUrl";

import ReservationScheduleTemplatesService, { ReservationScheduleTemplatePostModel, Weeks } from "@/commons/services/ReservationScheduleTemplates";

import Loading from "@/mobile/basics/Loading.vue";
import OkCancelModal from "@/mobile/basics/OkCancelModal.vue";
import OkModal from "@/mobile/basics/OkModal.vue";
import ValidationAlert from "@/pc/basics/ValidationAlertByValidator.vue";
import FormInput from "@/pc/components/forms/FormInput.vue";
import FormInputRadio from "@/pc/components/forms/FormInputRadio.vue";

@Component({
  components: {
    Loading,
    OkCancelModal,
    OkModal,
    ValidationAlert,
    FormInput,
    FormInputRadio
  },
  $_veeValidate: { validator: "new" }
})
export default class ReservationScheduleTemplateRegister extends Vue {
  /** 面会スケジュールテンプレートサービス */
  @Inject("ReservationScheduleTemplatesService") templateService!: ReservationScheduleTemplatesService;

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";
  /** 登録確認モーダル表示可否 */
  showRegisterModal: boolean = false;
  /** 登録完了モーダル表示可否 */
  showRegisterSuccessModal: boolean = false;

  /** バリデーションアラート表示可否 */
  showValidationAlert: boolean = false;

  /** 設定名 */
  name: string = "";

  /** 曜日入力情報 */
  weeks: Array<ExtWeeks> = [
    {
      /** 日曜 */
      sunday: false,
      /** 月曜 */
      monday: false,
      /** 火曜 */
      tuesday: false,
      /** 水曜 */
      wednesday: false,
      /** 木曜 */
      thursday: false,
      /** 金曜 */
      friday: false,
      /** 土曜 */
      saturday: false,

      /** 開始時間（時） */
      startHour: "",
      /** 開始時間（分） */
      startMin: "",
      /** 終了時間（時） */
      endHour: "",
      /** 終了時間（分） */
      endMin: "",

      /** 開始時間(時)の選択肢 */
      startHourOptions: [],
      /** 開始時間(分)の選択肢 */
      startMinOptions: [],
      /** 終了時間(時)の選択肢 */
      endHourOptions: [],
      /** 終了時間(分)の選択肢 */
      endMinOptions: []
    }
  ];

  /** 一括登録モーダルの開始(時)選択肢 */
  minHour: number = 8;
  /** 一括登録モーダルの開始(分)選択肢 */
  maxHour: number = 18;
  /** 一括登録モーダルの終了(時)選択肢 */
  minUnit: number = 15; // 仕様により、15分単位固定にする

  get watchedStartHours() {
    return this.weeks.map((week) => week.startHour);
  }

  /**
   * ### 開始時間(時)の値更新を監視する
   *
   * - 開始時間(時)を変更したら以降の入力項目を初期化する
   * - 選択肢が変更されている可能性があるので、選択肢も作り直す
   */
  @Watch("watchedStartHours")
  public changeStartHour(newValues: (string | number)[], oldValues: (string | number)[]): void {
    // 各要素のstartHourが変更された際の処理
    newValues.forEach((newValue, index) => {
      if (newValue !== oldValues[index]) {
        this.weeks[index].startMin = "";
        this.weeks[index].endHour = "";
        this.weeks[index].endMin = "";
        this.weeks[index].startMinOptions = this.createStartMinOptions();
        this.weeks[index].endHourOptions = this.createEndHourOptions();
        this.weeks[index].endMinOptions = this.createEndMinOptions();
      }
    });
    return;
  }

  get watchedStartMin() {
    return this.weeks.map((week) => week.startMin);
  }

  /**
   * ### 開始時間(分)の値更新を監視する
   *
   * - 開始時間(時)を変更したら以降の入力項目を初期化する
   * - 選択肢が変更されている可能性があるので、選択肢も作り直す
   */
  @Watch("watchedStartMin")
  public changeStartMin(newValues: (string | number)[], oldValues: (string | number)[]): void {
    // 各要素のstartHourが変更された際の処理
    newValues.forEach((newValue, index) => {
      if (newValue !== oldValues[index]) {
        this.weeks[index].endHour = "";
        this.weeks[index].endMin = "";
        this.weeks[index].endHourOptions = this.updateEndHourOptions(this.weeks[index]);
        this.weeks[index].endMinOptions = this.createEndMinOptions();
      }
    });
    return;
  }

  get watchedEndHour() {
    return this.weeks.map((week) => week.endHour);
  }

  /**
   * ### 終了時間(時)の値更新を監視する
   *
   * - 終了時間(時)を変更したら以降の入力項目を初期化する
   * - 選択肢が変更されている可能性があるので、選択肢も作り直す
   */
  @Watch("watchedEndHour")
  public changeEndHour(newValues: (string | number)[], oldValues: (string | number)[]): void {
    // 各要素のstartHourが変更された際の処理
    newValues.forEach((newValue, index) => {
      if (newValue !== oldValues[index]) {
        this.weeks[index].endMin = "";
        this.weeks[index].endMinOptions = this.updateEndMinOptions(this.weeks[index]);
      }
    });
    return;
  }

  /**
   * ### 開始時間(時)の選択肢を作成する
   *
   * - 時間範囲の最小値～(時間範囲の最大値-1)までを選択肢とする
   */
  public createStartHourOptions(): Array<string> {
    const options: Array<string> = [];
    for (let i = this.minHour; i < this.maxHour; i++) {
      options.push(String(i));
    }
    return options;
  }

  /**
   * ### 開始時間(分)の選択肢を作成する
   */
  public createStartMinOptions(): Array<string> {
    return this.createMinOptions();
  }

  /**
   * ### 分の選択肢を作成する
   *
   * - 分単位に応じて計算で求める
   */
  public createMinOptions(): Array<string> {
    const options: Array<string> = [];
    const unitCount: number = 60 / this.minUnit;
    for (let i = 0; i < unitCount; i++) {
      const min: number = i * (60 / unitCount);
      options.push(String(min).length == 1 ? String("0" + min) : String(min));
    }
    return options;
  }

  /**
   * ### 終了時間(時)の選択肢を作成する
   *
   * - 時間範囲の最小値～時間範囲の最大値までを選択肢とする
   */
  public createEndHourOptions(): Array<string> {
    const options: Array<string> = [];
    for (let i = this.minHour; i <= this.maxHour; i++) {
      options.push(String(i));
    }
    return options;
  }

  /**
   * ### 終了時間(分)の選択肢を作成する
   */
  public createEndMinOptions(): Array<string> {
    return this.createMinOptions();
  }

  /**
   * ### 終了時間(時)の選択肢を更新する
   *
   * - 開始時間より終了時間の方が未来になる必要があるため、終了時間(時)は開始時間(時)以降にする場合がある
   * - 開始時間(分)が選択できる開始時間(分)の末尾の場合、終了時間(時)は開始時間(時)+1になる
   * - 上記を考慮した上で終了時間(時)の選択肢を作成しなおす
   */
  public updateEndHourOptions(week: ExtWeeks): Array<string> {
    let options: Array<string> = [];
    let newEndHourStartPosition: number = Number(week.startHour);

    for (let i = 0; i < week.startMinOptions.length; i++) {
      if (week.startMinOptions[i] == week.startMin && i == week.startMinOptions.length - 1) {
        newEndHourStartPosition++;
      }
    }

    for (const endHourOption of week.endHourOptions) {
      if (newEndHourStartPosition <= Number(endHourOption)) {
        options.push(endHourOption);
      }
    }

    return options;
  }

  /**
   * ### 終了時間(分)の選択肢を更新する
   *
   * - 終了時間(時)が時間範囲の最大値と同じ場合、終了時間(分)は強制的に0のみとする
   * - 開始時間(時)と終了時間(時)が同じ場合、終了時間(分)は開始時間(分)より未来にする必要がある
   * - 上記以外は通常通り初期値の選択肢を使用する
   */
  public updateEndMinOptions(week: ExtWeeks): Array<string> {
    let options: Array<string> = [];

    if (week.endHour == String(this.maxHour)) {
      return ["00"];
    }

    if (week.startHour == week.endHour) {
      for (const min of week.endMinOptions) {
        if (Number(week.startMin) < Number(min)) {
          options.push(min);
        }
      }
    } else {
      options = this.createEndMinOptions();
    }

    return options;
  }

  /**
   * ### 開始時間(分)を入力不可にするかを返す
   */
  public startMinDisabled(week: Weeks): boolean {
    if (week.startHour != "") {
      return false;
    } else {
      return true;
    }
  }

  /**
   * ### 終了時間(時)を入力不可にするかを返す
   */
  public endHourDisabled(week: Weeks): boolean {
    if (week.startHour != "" && week.startMin != "") {
      return false;
    } else {
      return true;
    }
  }

  /**
   * ### 終了時間(分)を入力不可にするかを返す
   */
  public endMinDisabled(week: Weeks): boolean {
    if (week.startHour != "" && week.startMin != "" && week.endHour != "") {
      return false;
    } else {
      return true;
    }
  }

  /**
   * ### vue lifecycle mounted
   */
  public async mounted(): Promise<void> {
    await this.createView();
    return;
  }

  /**
   * ### 画面情報作成
   */
  public async createView(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    this.minHour = 8;
    this.maxHour = 18;
    this.minUnit = 15;

    for (const week of this.weeks) {
      week.startHourOptions = this.createStartHourOptions();
      week.startMinOptions = this.createStartMinOptions();
      week.endHourOptions = this.createEndHourOptions();
      week.endMinOptions = this.createEndMinOptions();
    }

    this.isBusy = false;

    return;
  }

  /**
   * ### 曜日情報を削除する
   */
  public onDeleteWeek(index: number): void {
    this.weeks.splice(index, 1);
    return;
  }

  /**
   * ### 曜日情報追加できないか
   */
  get _disableAddWeek(): boolean {
    if (20 <= this.weeks.length) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * ### 曜日情報を追加する
   */
  public onAddWeek(): void {
    if (this._disableAddWeek) {
      return;
    }
    this.weeks.push({
      /** 日曜 */
      sunday: false,
      /** 月曜 */
      monday: false,
      /** 火曜 */
      tuesday: false,
      /** 水曜 */
      wednesday: false,
      /** 木曜 */
      thursday: false,
      /** 金曜 */
      friday: false,
      /** 土曜 */
      saturday: false,

      /** 開始時間（時） */
      startHour: "",
      /** 開始時間（分） */
      startMin: "",
      /** 終了時間（時） */
      endHour: "",
      /** 終了時間（分） */
      endMin: "",

      /** 開始時間(時)の選択肢 */
      startHourOptions: this.createStartHourOptions(),
      /** 開始時間(分)の選択肢 */
      startMinOptions: this.createStartMinOptions(),
      /** 終了時間(時)の選択肢 */
      endHourOptions: this.createEndHourOptions(),
      /** 終了時間(分)の選択肢 */
      endMinOptions: this.createEndMinOptions()
    });
    return;
  }

  /**
   * ### 登録確認モーダルを表示する
   */
  public async showConfirmModal(): Promise<void> {
    const dayOfWeekValidationResult: boolean = await this.validateDayOfWeek();
    const validationResult: boolean = await this.$validator.validateAll();
    if (dayOfWeekValidationResult && validationResult) {
      this.showValidationAlert = false;
      this.showRegisterModal = true;
    } else {
      this.showValidationAlert = true;
    }
    return;
  }

  public async validateDayOfWeek(): Promise<boolean> {
    let valid: boolean = true;
    for (let i = 0; i < this.weeks.length; i++) {
      if (
        this.weeks[i].sunday == false &&
        this.weeks[i].monday == false &&
        this.weeks[i].tuesday == false &&
        this.weeks[i].wednesday == false &&
        this.weeks[i].thursday == false &&
        this.weeks[i].friday == false &&
        this.weeks[i].saturday == false
      ) {
        this.$validator.errors.add({ field: `day-of-week-${i}`, msg: `曜日は1つ以上選択する必要があります` });
        valid = false;
      } else {
        this.$validator.errors.remove(`day-of-week-${i}`);
      }
    }

    return valid;
  }

  /**
   * ### テンプレートを登録する
   */
  public async registerTemplate(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "登録中...";

    const requestBody: ReservationScheduleTemplatePostModel = this.createRequestBody();
    await this.templateService.post(userStore, requestBody);

    this.isBusy = false;
    this.showRegisterSuccessModal = true;
    return;
  }

  /**
   * ### 登録パラメータ作成
   */
  public createRequestBody(): ReservationScheduleTemplatePostModel {
    const weeks: Array<Weeks> = [];
    for (const week of this.weeks) {
      weeks.push({
        sunday: week.sunday,
        monday: week.monday,
        tuesday: week.tuesday,
        wednesday: week.wednesday,
        thursday: week.thursday,
        friday: week.friday,
        saturday: week.saturday,
        startHour: week.startHour,
        startMin: week.startMin,
        endHour: week.endHour,
        endMin: week.endMin
      });
    }

    const requestBody: ReservationScheduleTemplatePostModel = {
      name: this.name,
      weeks: weeks
    };
    return requestBody;
  }

  /**
   * ### テンプレート一覧に遷移する
   */
  public gotoTemplateList(): void {
    this.$router.push(PcUrl.ReservationScheduleTemplateList);
    return;
  }
}
export interface ExtWeeks extends Weeks {
  /** 開始時間(時)の選択肢 */
  startHourOptions: Array<string>;
  /** 開始時間(分)の選択肢 */
  startMinOptions: Array<string>;
  /** 終了時間(時)の選択肢 */
  endHourOptions: Array<string>;
  /** 終了時間(分)の選択肢 */
  endMinOptions: Array<string>;
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

#reservation-schedule-template-register {
  max-width: 740px;
  margin-left: auto;
  margin-right: auto;

  .register-radio-text {
    min-width: 80px;
  }

  .week-title {
    font-size: 18px;
    font-weight: bold;
    margin: 0 20px 0 20px;
  }
  .week-note {
    margin: 0 20px 0 20px;
  }
  .week {
    margin: 0 20px 0 20px;
    padding: 1rem;
    border: 1px solid $form-border-color;
    border-radius: 0.25rem;

    .register-row.input-week,
    .register-row.input-time {
      .register-group {
        margin: 0 !important;
      }
    }
  }
  .add-week {
    margin: 0 20px 0 20px;
  }

  .register-btn,
  .cancel-btn {
    width: 120px;
  }
}
</style>
